import { observer } from "mobx-react-lite";
import { FC } from "react";

import { Text } from "@bps/fluent-ui";
import { EmailColumnWrapper } from "@modules/practice/screens/address-book/components/contacts-lists/EmailColumnWrapper.tsx";
import { IndividualAndOrganisationNavigate } from "@modules/practice/screens/address-book/components/contacts-lists/Individual-organisation-columns/IndividualAndOrganisationNavigate.tsx";
import { useShowContactDetails } from "@modules/practice/screens/address-book/components/hooks/useShowContactDetails.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

export const IndividualAndOrganisationEmailColumn: FC<{
  contact: Contact;
  asPlainText?: boolean;
}> = observer(({ contact, asPlainText }) => {
  const showContactDetails = useShowContactDetails(contact);
  const MULTIPLE_EMAILS = "Multiple emails";

  return (
    <EmailColumnWrapper contact={contact}>
      {asPlainText ? (
        <Text>{MULTIPLE_EMAILS}</Text>
      ) : (
        <IndividualAndOrganisationNavigate
          contact={contact}
          onClick={() => showContactDetails()}
        >
          {MULTIPLE_EMAILS}
        </IndividualAndOrganisationNavigate>
      )}
    </EmailColumnWrapper>
  );
});
